import React from 'react'
import { Banner } from '@components/storybook'

const TopBanner = () => (
  <Banner
    height={['10rem', '20rem', '25rem']}
    backgroundImage="/passengers.jpeg"
    heading="Breeze Through Security"
    subHeading="Enroll today, no appointment needed."
    gradientStart="30%"
    showGradient
  />
)

export default TopBanner
